import apiService from '@/api/apiService';

export const getMissingEntries = async (balanceId, classType, typeId) => {
    const url = `/api/admin/asset_liability/missing_entries/${balanceId}`;

    // 建立查詢參數的物件
    const queryParams = {
        class: classType,
        type_id: typeId
    };

    // 將物件轉換為 URL 參數
    const searchParams = new URLSearchParams(queryParams);

    return apiService.GET(`${url}?${searchParams.toString()}`);
};
